import React, { useState } from 'react';
import PartnerLayout from '../../components/layout/PartnerLayout';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Plus, Sparkles, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import PartnerApplyServiceFlow, {
  PARTNER_SERVICE_CATALOG,
} from '../../components/partner/PartnerApplyServiceFlow';
import profileAssessmentIcon from '../../assets/Icon/Profile Assessment.png';
import preapplicationSupportIcon from '../../assets/Icon/Preapplication Support.png';
import applyUniversityIcon from '../../assets/Icon/Apply University.png';
import visaInterviewIcon from '../../assets/Icon/Visa & Interview Support.png';
import ticketTravelIcon from '../../assets/Icon/Ticket & Travel Support.png';
import accommodationIcon from '../../assets/Icon/Find Accommodation.png';
import educationLoanIcon from '../../assets/Icon/Education Loan.png';
import jobsAbroadIcon from '../../assets/Icon/Find Jobs Abroad.png';
import serviceImage1 from '../../assets/services-img/services-1.png';
import serviceImage2 from '../../assets/services-img/services-2.png';
import serviceImage3 from '../../assets/services-img/services-3.png';
import serviceImage4 from '../../assets/services-img/services-4.png';
import serviceImage5 from '../../assets/services-img/services-5.png';
import serviceImage6 from '../../assets/services-img/services-6.png';
import serviceImage7 from '../../assets/services-img/services-7.jpg';
import serviceImage8 from '../../assets/services-img/services-8.png';

export default function PartnerServices() {
  const [flowOpen, setFlowOpen] = useState(false);
  const [preselectedService, setPreselectedService] = useState('');
  const serviceVisuals = {
    PROFILE_ASSESSMENT: {
      iconAsset: profileAssessmentIcon,
      imageAsset: serviceImage1,
      shell: 'from-[#efe3ff] via-[#e3d2ff] to-[#d2b7ff]',
      glow: 'shadow-[0_10px_30px_rgba(168,125,250,0.25)]',
      border: 'border-[#9b6ffc]/55',
      tint: 'from-[#a87dfa]/48 via-[#a87dfa]/18 to-transparent',
      title: 'text-[#6d49d4]',
      chip: 'text-[#7a55df]',
      iconWrap: 'border-[#a87dfa]/40 bg-[#f3e9ff]',
      iconColor: 'text-[#7a55df]',
      button: 'border-[#a87dfa]/45 bg-[#f7efff] text-[#6d49d4] hover:bg-[#efe0ff]',
    },
    UNIVERSITY_SHORTLISTING: {
      iconAsset: preapplicationSupportIcon,
      imageAsset: serviceImage2,
      shell: 'from-[#e4f0ff] via-[#d2e6ff] to-[#bddbff]',
      glow: 'shadow-[0_10px_30px_rgba(111,168,255,0.24)]',
      border: 'border-[#6fa8ff]/55',
      tint: 'from-[#6fa8ff]/48 via-[#6fa8ff]/18 to-transparent',
      title: 'text-[#3f7edc]',
      chip: 'text-[#4a8cf1]',
      iconWrap: 'border-[#6fa8ff]/40 bg-[#edf5ff]',
      iconColor: 'text-[#4a8cf1]',
      button: 'border-[#6fa8ff]/45 bg-[#edf5ff] text-[#3f7edc] hover:bg-[#dfedff]',
    },
    APPLICATION_ASSISTANCE: {
      iconAsset: applyUniversityIcon,
      imageAsset: serviceImage3,
      shell: 'from-[#ffe3ee] via-[#ffd2e5] to-[#ffc0da]',
      glow: 'shadow-[0_10px_30px_rgba(255,155,194,0.24)]',
      border: 'border-[#ff9bc2]/55',
      tint: 'from-[#ff9bc2]/46 via-[#ff9bc2]/18 to-transparent',
      title: 'text-[#d45f93]',
      chip: 'text-[#dd6f9f]',
      iconWrap: 'border-[#ff9bc2]/40 bg-[#fff0f7]',
      iconColor: 'text-[#dd6f9f]',
      button: 'border-[#ff9bc2]/45 bg-[#fff0f7] text-[#d45f93] hover:bg-[#ffe3f0]',
    },
    VISA_GUIDANCE: {
      iconAsset: visaInterviewIcon,
      imageAsset: serviceImage4,
      shell: 'from-[#dffaf5] via-[#cdf4eb] to-[#b4eadf]',
      glow: 'shadow-[0_10px_30px_rgba(120,214,198,0.24)]',
      border: 'border-[#78d6c6]/55',
      tint: 'from-[#78d6c6]/46 via-[#78d6c6]/18 to-transparent',
      title: 'text-[#24998a]',
      chip: 'text-[#2aa898]',
      iconWrap: 'border-[#78d6c6]/40 bg-[#ecfffb]',
      iconColor: 'text-[#2aa898]',
      button: 'border-[#78d6c6]/45 bg-[#ecfffb] text-[#24998a] hover:bg-[#dcfaf3]',
    },
    SCHOLARSHIP_SEARCH: {
      iconAsset: ticketTravelIcon,
      imageAsset: serviceImage5,
      shell: 'from-[#fff0d8] via-[#ffe5be] to-[#ffd497]',
      glow: 'shadow-[0_10px_30px_rgba(255,191,102,0.24)]',
      border: 'border-[#ffbf66]/55',
      tint: 'from-[#ffbf66]/46 via-[#ffbf66]/18 to-transparent',
      title: 'text-[#d28a20]',
      chip: 'text-[#e59a28]',
      iconWrap: 'border-[#ffbf66]/40 bg-[#fff7ea]',
      iconColor: 'text-[#e59a28]',
      button: 'border-[#ffbf66]/45 bg-[#fff7ea] text-[#d28a20] hover:bg-[#ffeed4]',
    },
    ACCOMMODATION_HELP: {
      iconAsset: accommodationIcon,
      imageAsset: serviceImage6,
      shell: 'from-[#e2f7dc] via-[#d1efc8] to-[#b8e4ab]',
      glow: 'shadow-[0_10px_30px_rgba(143,209,127,0.24)]',
      border: 'border-[#8fd17f]/55',
      tint: 'from-[#8fd17f]/46 via-[#8fd17f]/18 to-transparent',
      title: 'text-[#4e9b40]',
      chip: 'text-[#5aa64a]',
      iconWrap: 'border-[#8fd17f]/40 bg-[#f1ffec]',
      iconColor: 'text-[#5aa64a]',
      button: 'border-[#8fd17f]/45 bg-[#f1ffec] text-[#4e9b40] hover:bg-[#e3f8db]',
    },
    LOAN_ASSISTANCE: {
      iconAsset: educationLoanIcon,
      imageAsset: serviceImage7,
      shell: 'from-[#dff3ff] via-[#caeaff] to-[#addbff]',
      glow: 'shadow-[0_10px_30px_rgba(126,200,255,0.24)]',
      border: 'border-[#7ec8ff]/55',
      tint: 'from-[#7ec8ff]/46 via-[#57a8ff]/18 to-transparent',
      title: 'text-[#3b84c7]',
      chip: 'text-[#4794db]',
      iconWrap: 'border-[#7ec8ff]/40 bg-[#edf8ff]',
      iconColor: 'text-[#4794db]',
      button: 'border-[#7ec8ff]/45 bg-[#edf8ff] text-[#3b84c7] hover:bg-[#dff1ff]',
    },
    PRE_DEPARTURE_ORIENTATION: {
      iconAsset: jobsAbroadIcon,
      imageAsset: serviceImage8,
      shell: 'from-[#ffe4dd] via-[#ffd3c8] to-[#ffbdac]',
      glow: 'shadow-[0_10px_30px_rgba(255,159,139,0.24)]',
      border: 'border-[#ff9f8b]/55',
      tint: 'from-[#ff9f8b]/46 via-[#ff9f8b]/18 to-transparent',
      title: 'text-[#d36852]',
      chip: 'text-[#e17a65]',
      iconWrap: 'border-[#ff9f8b]/40 bg-[#fff1ed]',
      iconColor: 'text-[#e17a65]',
      button: 'border-[#ff9f8b]/45 bg-[#fff1ed] text-[#d36852] hover:bg-[#ffe2d9]',
    },
  };

  const handleApply = (serviceType) => {
    setPreselectedService(serviceType);
    setFlowOpen(true);
  };

  return (
    <PartnerLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="partner-card rounded-[28px] p-6 lg:p-8">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between">
            <div>
            <div className="mb-1 flex items-center gap-2">
              <Sparkles className="w-5 h-5 text-[#8D68E8]" />
              <h1 className="text-3xl font-bold text-slate-900">Services</h1>
            </div>
            <p className="text-slate-600">
              Apply for any Fly8 service on behalf of your students.
            </p>
          </div>
          <Button
            onClick={() => {
              setPreselectedService('');
              setFlowOpen(true);
            }}
            className="partner-primary-btn rounded-2xl"
          >
            <Plus className="w-4 h-4 mr-2" />
            New Request
          </Button>
          </div>
        </div>

        {/* Service Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {PARTNER_SERVICE_CATALOG.map((s, idx) => {
            const Icon = s.icon;
            const visuals = serviceVisuals[s.serviceType] || {};
            return (
              <motion.div
                key={s.serviceType}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.04 }}
              >
                <Card
                  className={`partner-card partner-card-hover flex h-full flex-col rounded-[28px] border bg-gradient-to-br p-4 ${visuals.shell || 'from-white/70 to-white/40'} ${visuals.border || 'border-[#A87DFA]/24'} ${visuals.glow || ''}`}
                >
                  <div className={`absolute inset-x-0 top-0 h-28 rounded-t-[28px] bg-gradient-to-b ${visuals.tint || 'from-[#A87DFA]/20 via-[#A87DFA]/8 to-transparent'} pointer-events-none`} />
                  <div className="relative mb-4 overflow-hidden rounded-[22px] border border-[#A87DFA]/18">
                    <img
                      src={visuals.imageAsset}
                      alt={s.label}
                      className="h-40 w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.04),rgba(255,255,255,0.18))]" />
                    <div className="absolute left-4 top-4 flex h-14 w-14 items-center justify-center rounded-[18px] border border-white/25 bg-white/20 backdrop-blur-md">
                      {visuals.iconAsset ? (
                        <img src={visuals.iconAsset} alt="" className="h-8 w-8 object-contain" />
                      ) : (
                        <Icon className="h-6 w-6 text-white" />
                      )}
                    </div>
                    <div className="absolute bottom-4 left-4">
                      <div className={`rounded-full border border-white/35 bg-white/55 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] backdrop-blur-md ${visuals.chip || 'text-[#7A55DF]'}`}>
                        Fly8 Service
                      </div>
                    </div>
                  </div>
                  <div className="mb-3 flex items-center gap-2 text-xs font-medium uppercase tracking-[0.18em] text-[#8D68E8]">
                    <div className={`flex h-9 w-9 items-center justify-center rounded-2xl border ${visuals.iconWrap || 'border-[#A87DFA]/16 bg-[linear-gradient(135deg,rgba(168,125,250,0.16),rgba(168,125,250,0.05))]'}`}>
                      <Icon className={`h-4 w-4 ${visuals.iconColor || 'text-[#7A55DF]'}`} />
                    </div>
                    <span className={visuals.chip || 'text-[#7A55DF]'}>Partner Service</span>
                  </div>
                  <h3 className={`mb-2 text-xl font-semibold ${visuals.title || 'text-[#6d49d4]'}`}>
                    {s.label}
                  </h3>
                  <p className="mb-4 flex-1 text-sm text-slate-600">
                    {s.description}
                  </p>
                  <Button
                    onClick={() => handleApply(s.serviceType)}
                    variant="outline"
                    className={`group w-full rounded-2xl border bg-white/65 ${visuals.button || 'partner-secondary-btn'}`}
                  >
                    Apply Now
                    <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-0.5" />
                  </Button>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </div>

      <PartnerApplyServiceFlow
        open={flowOpen}
        onOpenChange={setFlowOpen}
        initialServiceType={preselectedService}
      />
    </PartnerLayout>
  );
}
